import React from 'react'
import CanadaLogo from '../../assets/images/StartScreen/Canada_Logo.png';
import CanadaLogoFR from '../../assets/images/StartScreen/FR_Canada_Logo.png';
import CNELogo from '../../assets/images/StartScreen/CNE_Logo.png';
import "./landing.css";

const LandingPage = (props) => {
    const eventHandler = (event) => {

        props.goToStep(event, 'GeneralIntro');
    }

    return (<>
        <div className="Landing fullscreen">
            <div className="Logos">
            <img className='Landing-item2' src={CNELogo} alt='CNE Logo' />
               <div className='gameName'>
               Plushie
               </div>
               <div className='gameName'>Pursuit:</div>
               <div className='gameTitle'>A CNE Mystery Game</div>
                
            </div>
            <div className='StartButton' onClick={eventHandler} >
                Start
            </div>
            <div className='govLogos'>
                    <img className='Landing-item1' src={CanadaLogo} alt='Canadian Logo' />
                    <img className='Landing-item1' src={CanadaLogoFR} alt='Canadian Logo French' />
                </div>

        </div>
    </>
    );
}

export default LandingPage;